import { CaseStage } from "app/settings/category-setup/category-setup.component";

export class ChooseTimeInput {
  public startTime: string;
  public endTime: string;
  public fitter: string;
}

export class CompanyInformation {
  public name: string;
  public address: string;
  public companyAddress: string;
  public companyZipCode: string;
  public companyCity: string;
  public id: string;
  public phone : string;
  public logo: string;
  public email: string;
  public companyLanguage: 'da-DK' | 'sv-SE' | 'en-US' | 'nn-NO' | 'es-ES' | 'fo-FO' | 'de-DE';
  public companyNumber: number;
  public companyType: string;
  public googleAnalyticsId: string;
  public originId: string;
  public vat: string;
  public base64? : string;
  public website: string;
}

export class CustomerDetails {
  address: string;
  customerId?: string;
  email: string;
  mobile: string;
  phone: string;
  name: string;
  zipCode: string;
  city: string;
  cvr?: string;
}

export class AddressDetails {
  address: string;
  id: string;
  email: string;
  mobile: string;
  phone: string;
  name: string;
  zipCode: string;
  city: string;
}

export class DeliveryAddressDetails {
  address: string;
  id: string;
  email: string;
  mobile: string;
  phone: string;
  name: string;
  zipCode: string;
  city: string;
}

export class Department {
  public companyId: string;
  public createdAt: string;
  public departmentBelongToId: string;
  public departmentBelongToName: string;
  public departmentId: string;
  public description: string;
  public lastModified: Date;
  public name: string;
}

export class FileInput {
  public fileId = [];
  public fileName = [];
  public ext = [];
  public originalName = '';
}

export class FileOutput {
  public extension: string = '';
  public fileId: string = '';
  public fileTypeId: string = '';
  public originalName: string = '';
  public path: string = '';
}

export class Fitter {
  public fitterId: string;
  public name: string;
}

export class KeyValue {
  public key: string;
  public value: string;
}

export class Lists {
  public responsibles: Array<KeyValue> = [];
  public departments: Array<Department> = [];
  public skills: Array<Skill> = [];
  public status: Array<Status> = [];
  public tasks: Array<Task> = [];
  public priceGroups: Array<PriceGroup>;
  public pendingMessages: Array<PendingMessage>;
  offerListFiltered: Array<any>;
  public caseStages: Array<CaseStage> = [];
}

export class Message {
  public caseId: string = '';
  public description: string = '';
  public fileId: string = '';
  public files: FileOutput = new FileOutput();
  public messageId: string = '';
  public messageTypeId = '';
  public sentAt: string = '';
  public sentBy: Stakeholder = new Stakeholder();
  public title: string = '-';
  public messageReadByCustomer: boolean;
  public emailSent: boolean;
  public smsSent: boolean;
}

export class PendingMessage {
  public email: string;
  public id: string;
  public messageTypeId: string;
  public sendingAt: string;
  public shortDescription: string;
  public sms: string;
  date?: string;
  time: string;
}

export class BookingOnCase {
  receiverId: string = null;
  receiver: number = null;
  isBookable: boolean = true;
  skillId: string = null;
  priceGroupId: string = null;
}

export class MessageTypes {
  public customer = [
    '77e3ae35-6955-4fbb-89a9-1992ee407dd6',
    'b493822e-bae1-4e96-889c-ae5f821c6473',
    '89a873df-acda-41ca-a680-c40f20f7329e'
  ];
  public system = [
    'b2114c29-d297-4a12-bda5-a400fbcaaf40',
    '1aabee02-1576-4dad-a995-3e8c272f8e82',
    '87806a15-0ae5-44a9-ba2e-ff2402b1345f',
    'c2de85a8-7ce7-4e1c-a229-5279e4ea5f2b',
    '8c300432-6ff5-4e6a-a259-1fb0e9877cbf',
    '8850aee1-48a3-48a6-aa98-2e1597b7b1d7',
    '99bc09b6-b7f7-46c0-a40b-5dfc27ec9cf0',
    '7bccdf15-ad49-4cc9-b358-68e08287f32f',
    'b56c96f0-0e8c-4a9f-8faf-70eea6f6b0b7',
    'a693c47f-9685-4bb6-bf6e-bcab86cb88de',
    '6bef49c6-c9a1-4fd3-ae13-e9b28dfc7b6b',
    'dbe287c5-6011-47f3-88e8-eafa671d1ed6',
    '7f42fb44-d8ea-491f-8bfc-0b63a5276ddf'
  ];
  public company = [
    'c3affd15-1834-44ff-9c5e-11763e6aabed',
    'd8e8ed6f-8582-4f0a-bc26-1307f32825ed',
    '880a69de-65ea-4bd0-96bb-238999075b5b',
    '403358d3-f766-43c6-aa19-276c40c9cf5a',
    'e16ffab0-bbac-4a90-906c-27ec935deba4',
    '69d4f294-ca74-4df1-b018-2e2779e775c5',
    '6deaca71-b600-4f4a-8923-3e5286190f4a',
    '8c0e89f8-0186-4ded-96a1-806fa7846523',
    'affa0591-e431-4543-a005-9200d71e5948',
    '5bd55f91-ae0b-4289-911d-a4037a244360',
    'd9cac90c-6aff-4067-8666-a61d07077379',
    '1f960a12-f5a8-4cd3-a474-bb41fd68a026',
    '04630a3b-6f6e-4c24-be3a-f56a0499c8c4',
    '47324550-1525-4d66-b975-f8c9c9301b15'
  ];
  public internal = ['5bd55f91-ae0b-4289-911d-a4037a244360'];
}

export class Origin {
  public originId: string;
  public url: string;
}

export class Responsible {
  public responsibleId: string;
  public name: string;
}

export class Skill {
  public description: string = '';
  public name: string;
  public packageDistributorId: string;
  public skillId: string;
}

export class Procurement {
  id: string;
  name: string;
  icon: string = "fas fa-question";
}

export class Enterprise {
  id: string;
  name: string;
  icon: string = "fas fa-question";
}

export class Stakeholder {
  public stakeholderId: string = '';
  public name: string = '';
}

export class Status {
  caseStatusId: string;
  name: string;
  description: string;
  createdAt: string;
  lastModified: string;
}

export class Task {
  public caseTaskStatus: KeyValue;
  public caseTaskType: KeyValue;
  public endDateTime: string;
  public fitter: KeyValue;
  public startDateTime: string;
  public taskId: string;
}

export class PriceGroup {
  public priceGroupId: string;
  public description: string;
  public name: string;
  public costPrice: number;
  public listPrice: number;
  public companyId: string;
  public createdAt: string;
  public lastModified: string;
}
